import React from "react";
import {BrowserRouter as Router, Routes, Link, Route} from "react-router-dom";
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';

import Home from "./Home";
import Info from "./Info";
import Identity from "./Identity";
//import SubScription from "./SubScription";
import GuideOverView from "./GuideOverView";
import PlanOfAction from "./PlanOfAction";
import GuideRecruit from "./GuideRecruit";
import InternShip from "./InternShip";
import Recruit from "./Recruit";
import GuideFacility from "./GuideFacility";
import Hall from "./Hall";
import GuideService from "./GuideService";
import Tour from "./Tour";
import TourAlbum2018 from "./TourAlbum2018";
import TourAlbum2019 from "./TourAlbum2019";
import TourAlbum2020 from "./TourAlbum2020";
import TourAlbum2021 from "./TourAlbum2021";
import TourAlbum2022 from "./TourAlbum2022";
import TourAlbum2023 from "./TourAlbum2023";
import TourAlbum2024 from "./TourAlbum2024";
import TourAlbum2025 from "./TourAlbum2025";
import TourAlbum2026 from "./TourAlbum2026";
import PrintService from "./PrintService";
import Support from "./Support";
import GuideEvent from "./GuideEvent";
import Ticket from "./Ticket";
import GuideWanted from "./GuideWanted";
import GakuseiBungei from "./GakuseiBungei";
import ChildPainting from "./ChildPainting";
import GuideAdvertisement from "./GuideAdvertisement";
import Advertisement from "./Advertisement";
import Flyer from "./Flyer";
import FlyerDetail from "./FlyerDetail";
import DigitalFlyer from "./DigitalFlyer";
import GuideBusiness from "./GuideBusiness";
import RelayInfo from "./RelayInfo";
import Forum from "./Forum";
import ForumHistory from "./ForumHistory";
import Award from "./Award";
import AwardDelion from "./AwardDelion";
import AwardKigyo from "./AwardKigyo";
import NewsPaperReport from "./NewsPaperReport";
import GuideBook from "./GuideBook";
import Book from "./Book";
import GuideShop from "./GuideShop";
import Shop from "./Shop";
import GuideContactUs from "./GuideContactUs";
import GuideTerms from "./GuideTerms";
/*
import DailyRight from "./DailyRight";
*/
import GuideDelion from "./GuideDelion";
import ContactUs from "./ContactUs";
import QuestionAnswer from "./QuestionAnswer";
import Footer from "./Footer";

const topPage = () => <div><h1>Top Page</h1>ここがトップページです</div>
const page404 = () => <div><h1>404</h1>存在しないページです</div>  //<= ヒットしなかった時用のページを追加
//const page999 = () => <Container maxWidth="md"><Identity /></Container>
const page999 = () => <div><Identity /><Footer /></div>


const Menu = () => {
  return (
    <Router>
      <Box className="main-wrap">
        <Routes>
          <Route path='/' exact element={<Home />}/>
          <Route path='/info' exact element={<Info />}/>
          <Route path='/identity' exact element={<Identity />}/>
          <Route path='/planofaction' exact element={<PlanOfAction />}/>
          {/* <Route path='/history' exact element={<History />}/> */}
          <Route path='/internship' exact element={<InternShip />}/>
          <Route path='/recruit' exact element={<Recruit />}/>
          <Route path='/tour' exact element={<Tour />}/>
          <Route path='/tour/album/2018' exact element={<TourAlbum2018 />}/>
          <Route path='/tour/album/2019' exact element={<TourAlbum2019 />}/>
          <Route path='/tour/album/2020' exact element={<TourAlbum2020 />}/>
          <Route path='/tour/album/2021' exact element={<TourAlbum2021 />}/>
          <Route path='/tour/album/2022' exact element={<TourAlbum2022 />}/>
          <Route path='/tour/album/2023' exact element={<TourAlbum2023 />}/>
          <Route path='/tour/album/2024' exact element={<TourAlbum2024 />}/>
          <Route path='/tour/album/2025' exact element={<TourAlbum2025 />}/>
          <Route path='/tour/album/2026' exact element={<TourAlbum2026 />}/>
          {/* <Route path='/event' exact element={<Event />}/> */}
          {/* <Route path='/guide-business/childpainting' exact element={<ChildPainting />}/> */}
          {/* <Route path='/event/newspaperreport' exact element={<NewsPaperReport />}/> */}
          {/* <Route path='/bunka/gakuseibungei' exact element={<GakuseiBungei />}/> */}
          <Route path='/forum' exact element={<Forum />}/>
          <Route path='/forum/history' exact element={<ForumHistory />}/>
          <Route path='/award' exact element={<Award />}/>
          <Route path='/award-delion' exact element={<AwardDelion />}/>
          <Route path='/award-kigyo' exact element={<AwardKigyo />}/>
          <Route path='/support' exact element={<Support />}/>
          {/* <Route path='/subscription' exact element={<SubScription />}/> */}
          <Route path='/shop' exact element={<Shop />}/>
          <Route path='/hall' exact element={<Hall />}/>
          <Route path='/book' exact element={<Book />}/>
          <Route path='/printservice' exact element={<PrintService />}/>
          <Route path='/ticket' exact element={<Ticket />}/>
          <Route path='/advertisement' exact element={<Advertisement />}/>
          <Route path='/flyer' exact element={<Flyer />}/>
          <Route path='/flyerdetail' exact element={<FlyerDetail />}/>
          <Route path='/digitalflyer' exact element={<DigitalFlyer />}/>
          <Route path='/guide-overview' exact element={<GuideOverView />} />
          <Route path='/guide-recruit' exact element={<GuideRecruit />} />
          <Route path='/guide-facility' exact element={<GuideFacility />} />
          <Route path='/guide-service' exact element={<GuideService />} />
          {/* <Route path='/guide-event' exact element={<GuideEvent />} /> */}
          <Route path='/guide-wanted' exact element={<GuideWanted />} />
          <Route path='/guide-advertisement' exact element={<GuideAdvertisement />} />
          {/* <Route path='/guide-business' exact element={<GuideBusiness />} /> */}
          <Route path='/relay-info' exact element={<RelayInfo />} />
          <Route path='/guide-book' exact element={<GuideBook />} />
          <Route path='/guide-shop' exact element={<GuideShop />} />
          <Route path='/guide-contactus' exact element={<GuideContactUs />} />
          <Route path='/guide-terms' exact element={<GuideTerms />} />
          {/* <Route path='/daily-right' exact element={<DailyRight />} /> */}
          <Route path='/guide-delion' exact element={<GuideDelion />} />
          <Route path='/question-answer' exact element={<QuestionAnswer />} />
          <Route path='/contactus' exact element={<ContactUs />} />
          <Route exact element={<page404 />}/>
        </Routes>
      </Box>
    </Router>
  )
}

export default Menu;
